"use client";

import { Controls } from "@/components/meds/meds-search/controls/controls";
import { MedsList } from "@/components/meds/meds-search/meds-list/meds-list";
import { InfiniteScroll } from "@/components/common/infinite-scroll";
import { resolveInitialFilters } from "@/components/meds/meds-search/search-content/service";
import { createPath } from "@/service/routing/routing";
import { EmptyInfoWithCta } from "@/components/common/empty-info-with-cta";

export const SearchContent = ({
  pagination,
  filters,
  searchParams,
  search = undefined,
  hideKinds = false,
}: {
  pagination: Pagination<MedGroupPreviewVM>;
  filters: MedsSearchFilters;
  searchParams: Record<string, string>;
  search?: string;
  hideKinds?: boolean;
}) => {
  const paramsHasFilter =
    "price" in searchParams ||
    "kinds" in searchParams ||
    "forNurse" in searchParams ||
    "withoutPrescription" in searchParams;

  const items = pagination.results;
  const kindsOptions = filters[1].options;

  const isNotEmpty =
    items.length > 0 || paramsHasFilter || kindsOptions.length > 0;

  return isNotEmpty ? (
    <>
      <Controls
        hideKinds={hideKinds}
        filters={resolveInitialFilters(filters, searchParams)}
      />

      <MedsList
        items={items}
        paramsHasFilter={paramsHasFilter}
        search={search}
      />

      <InfiniteScroll pagination={pagination} />
    </>
  ) : (
    <EmptyInfoWithCta link={createPath("meds.index")} />
  );
};
